module.exports = __webpack_public_path__ + "img/Speedometer.a1a38ca6.svg";